<template>
  <v-scroll-y-transition origin="center center 0">
    <v-sheet
      v-show="loading"
      class="absolute--sheet fill-bounds"
      v-bind:style="{ background: 'none', zIndex }"
    >
      <div
        class="sheet-loader--mask d-flex justify-center align-center"
        v-bind:style="{
          backgroundColor: `rgba(255, 255, 255, ${backgroundOpacity})`,
        }"
      >
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-sheet>
  </v-scroll-y-transition>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    backgroundOpacity: {
      type: String,
      default: () => '0.5',
    },
    zIndex: {
      type: Number,
      default: () => 1,
    },
  },
};
</script>

<style lang="scss" scoped>
  .absolute--sheet,
  .sheet-loader--mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .fill-bounds {
  }

  .sheet-loader--mask {
  }
</style>
